export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_16.c8b5a088.jpg";